module.exports = __webpack_public_path__ + "img/twitter_gray.6e3cbb60.svg";